import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Master from "./MasterLayout/Master";
import { AdminRoutes } from "./Route";
import LoginPage from "./Pages/login/login";
import NotFound from "./Components/NotFound";
import ProtectedRoute from "./ProtectedRoute";
import VendorQuoteResponse from "./Pages/quotes/VendorQuoteResponse";
import "./App.css";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route path="/" element={<LoginPage />} />
        {/* Vendor self-service form — opened via tokenized link in WTB emails.
            No ProtectedRoute / Master layout (external, not logged in). */}
        <Route path="/vendor-response/:token" element={<VendorQuoteResponse />} />

        {/* ADMIN ROUTES (PROTECTED) */}
        {AdminRoutes.map((route) => {
          const Component = route.component;

          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                <ProtectedRoute>
                  <Master>
                    <Component />
                  </Master>
                </ProtectedRoute>
              }
            />
          );
        })}

        {/* FALLBACK */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;